import React from 'react';
import { SvgIcon } from 'components/SvgIcon';
import { IThankYou } from 'services/ThankYouService';
import { enNormalizedPaymentType } from 'enums/enPaymentMethod';

interface IProps {
  model: IThankYou;
}

export const Physical = (props: IProps) => (
  <React.Fragment>
    <div className={'message'}>
      {props.model.paymentResult.paymentMethod === enNormalizedPaymentType.BANKSLIP ?
        <p>Você receberá no seu <b>e-mail</b> o código de rastreio do seu produto assim que
         o pagamento do boleto for confirmado. Enquanto isso, confirme os seus dados de compra.</p> :
        <p>Estamos preparando com carinho a entrega do seu produto. Você receberá no seu <b>e-mail</b> o código de
        rastreio do seu produto. Enquanto isso, confirme os seus dados de compra.</p>
      }
    </div>
    <div className={'data'}>
      <div className={'user'}>
        <p><SvgIcon name='email' /><span>{props.model.user.email}</span></p>
        <p>
          <SvgIcon name='truck' />
          <span>{props.model.user.address.street}, {props.model.user.address.number}, {props.model.user.address.district},&nbsp;
            {props.model.user.address.city} - {props.model.user.address.province} - {props.model.user.address.postalCode}</span></p>
      </div>
    </div>
    <div className={'alert'}>
      Em caso de dúvidas, ou se você precisar de suporte, entre em contato com o vendedor pelo e-mail <b>{props.model.content.producerEmail}</b>.
    </div>
  </React.Fragment>
);